/**
 * Datetime Utility for consistent date formatting across eQuote
 * Formats all dates to standard DD/MM/YYYY with leading zeros.
 */

export function formatDate(input?: string | Date | null): string {
  if (!input) return 'Hôm nay';

  if (input instanceof Date) {
    const day = String(input.getDate()).padStart(2, '0');
    const month = String(input.getMonth() + 1).padStart(2, '0');
    const year = input.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const str = String(input).trim();
  if (!str) return 'Hôm nay';

  // If already formatted as D/M/YYYY or DD/MM/YYYY
  if (str.includes('/')) {
    const parts = str.split('/');
    if (parts.length === 3) {
      const day = parts[0].trim().padStart(2, '0');
      const month = parts[1].trim().padStart(2, '0');
      const year = parts[2].trim();
      return `${day}/${month}/${year}`;
    }
  }

  // Parse ISO string or date timestamp
  const parsed = new Date(str);
  if (!isNaN(parsed.getTime())) {
    const day = String(parsed.getDate()).padStart(2, '0');
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const year = parsed.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return str;
}

export function getCurrentFormattedDate(): string {
  return formatDate(new Date());
}
